import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DialogContentLayoutModule } from '@avenir-client-web/dialog-content-layout';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-backward-confirmation',
  templateUrl: './backward-confirmation.component.html',
  styleUrls: ['./backward-confirmation.component.scss'],
  imports: [CommonModule, DialogContentLayoutModule],
})
export class BackwardConfirmationComponent {
  saveLabel = $localize`default.action.ok`;

  constructor(private readonly dialogRef: DynamicDialogRef) {}

  close(isConfirm?: boolean): void {
    this.dialogRef.close(isConfirm);
  }
}
